import React, { Component } from 'react';
import gramUtils, { getDisplayUnit, getUnit } from '../../utils/gramUtils';
import models from '../../model/models';

export default class Volume extends Component {
	render() {
		return Volume.inPreferredUnit(this.props.value, this.props.type) + ' ' + getDisplayUnit(this.props.type);
	}

	static inPreferredUnit = (mcgQuantity, type) => {
		if (getUnit(type) === 'mg') {
			return mcgQuantity / 1000;
		} else if (getUnit(type) === 'g') {
			return mcgQuantity / (1000 * 1000);
		}
		return mcgQuantity;
	};
	static toMicrograms = (quantityInPreferredUnit, type) => {
		if (getUnit(type) === 'mg') {
			return quantityInPreferredUnit * 1000;
		} else if (getUnit(type) === 'g') {
			return quantityInPreferredUnit * 1000 * 1000;
		}
		return quantityInPreferredUnit;
	};
	static unit = (type) => {
		return getUnit(type);
	};
}



// WEBPACK FOOTER //
// ./src/components/volume/Volume.jsx